import SendSMS from './SendSMS';

export default SendSMS;
